export default __webpack_public_path__ + "static/media/order.d45d05cf.png";